import React, { useEffect, useState } from 'react';
import Layout from '../../components/common/pageLayout';
import Form from '../../components/Attendance/form';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { v3_attendanceDetails, v3_attendanceSubmit } from '../../actions/v3/attendance';
import { toast } from 'react-toastify';
import constant from '../../constant';

const Add = (props) => {

    const location = useLocation();
    const { project } = location.state || {};

    const [data, setData] = useState(null);


    // State for attendance date
    const [attendanceDate, setAttendanceDate] = useState('');

    const onSubmit = (model) => {

        v3_attendanceSubmit({ rows: model, projectId: project.PROJECT_ID, attendanceDate }).then((res) => {
            if (res.status) {
                toast.success(res.result.message);
                props.history.push(constant.Authedcomponent.attendanceProjectList.url);
            }
            else {
                toast.error(res.error || res.error.message)
            }
        })
    };

    useEffect(() => {
        if (attendanceDate) {
            v3_attendanceDetails(project.PROJECT_ID, attendanceDate).then((res) => {
                if (res.status) {
                    setData(res.result.rows)
                }
            })
        }

    }, [attendanceDate, project])
    return (
        <Layout title="Attendance ">

            <div className="row">
                <div className="col-lg-12">
                    <div className="card" id={1}>
                        <div className="card-body"></div>
                        <div className="checklist-title-bx">
                            <div className="row">
                                <div className="col-md-10">
                                    <div className="text-center">
                                        <h4>{project?.PROJECT_NAME} Project Time Sheet</h4>

                                    </div>
                                </div>
                                <div className="col-md-2 text-end">
                                    {/* Date field */}
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={attendanceDate}
                                        onChange={(e) => setAttendanceDate(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>

                        <Form
                            buttonName="Apply"
                            onSubmit={onSubmit}
                            data={data}
                        />


                    </div>
                </div>
            </div >

        </Layout>
    );
};

export default Add;
